import React, { useEffect } from 'react';

function AboutPage({ onBack }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Animated Background Elements */}
      <div className="about-bg-decoration"></div>
      
      {/* Top Navigation Bar */}
      <div className="about-top-bar">
        <div className="about-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="about-title-text">About</div>
        <div className="about-spacer"></div>
      </div>

      {/* Hero Section for Company Name and Tagline */}
      <div className="about-hero-section">
        <div className="about-hero-glow"></div>
        <div className="about-hero-content-wrapper">
          <div className="about-company-name">Circana RELATIONS</div>
          <div className="about-tagline">WE CREATE TRUST. I PROMISE.</div>
        </div>
      </div>

      {/* Content Area */}
      <div className="about-content">
        <div className="about-paragraph">
        Circana is a leader in providing technology, AI, and data to fast-moving consumer packaged goods companies, durables manufacturers, and retailers seeking to optimize their businesses.
        </div>

        <div className="about-paragraph">
        Circana's predictive analytics and technology empower clients to measure their market share, understand the underlying consumer behavior driving it, and accelerate their growth. <br /> 
        Circana's Liquid Data® technology platform is powered by an expansive, high-quality data set and intelligent algorithms trained on six decades of domain expertise. With Circana, clients can take immediate action to future-proof and evolve their growth strategies amid an increasingly complex, fast-paced, and ever-changing economy.

        </div>

        <div className="about-closing">On this, our word.</div>
      </div>
    </div>
  );
}

export default AboutPage;

